import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 2.087 2.087 0 3.5 1.413 1.413 3.5zM13.913 0 16 2.087 14.587 3.5 12.5 1.413z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 9A7 7 0 1 1 1 9a7 7 0 0 1 14 0M9 4v4.586l2.707 2.707-1.414 1.414L7 9.414V4z",
		clipRule: "evenodd"
	})]
});
export default SvgClock;
